import { useMemo } from 'react'
import { Offer } from '@/services/PifService'
import { getPeopleImpacted } from '@/services/PifService/PifService'
import { useLocale } from '@/utils/LocaleUtil'

interface Props {
  offer: Offer | null
}

export const usePifOfferTickets = ({ offer }: Props) => {
  const { locale } = useLocale()

  const numberOfTickets = useMemo(() => {
    if (!offer) return null
    return getPeopleImpacted(offer)
  }, [offer])

  const formattedNumberOfTickets = useMemo(() => {
    if (numberOfTickets == null) return null
    return new Intl.NumberFormat(locale).format(numberOfTickets)
  }, [locale, numberOfTickets])

  return useMemo(() => {
    return { numberOfTickets, formattedNumberOfTickets }
  }, [formattedNumberOfTickets, numberOfTickets])
}
